import React from 'react';
import {StyleSheet, View} from 'react-native';

import Button from '../../components/ui-controls/Button';
import ContentView from '../../components/ui-controls/layout/ContentView';
import Text from '../../components/ui-controls/Text';
import theme from '../../style/theme';

type MemberOnlyAccessViewProps = {
  isLoggedIn: boolean;
  onSignIn: () => void;
};

/**
 * Access outcome shown instead of promotion content when the viewer fails the
 * members-only gate (`membersOnly && !(isLoggedIn && loyaltyEnabled)`).
 *
 * Copy tracks the predicate, not Rewards membership: logged out is fixable by
 * signing in, logged in with a non-loyalty store is not, so only the former
 * gets a CTA. Navigation is the host's concern — this view stays hook-free so
 * it renders anywhere the gate is evaluated (DIS-1566 AC-5.4).
 */
const MemberOnlyAccessView = ({isLoggedIn, onSignIn}: MemberOnlyAccessViewProps) => (
  <ContentView testID="promotion-detail-screen-promotion-not-found-member-only">
    <View style={styles.textCard}>
      <Text style={styles.headline}>Member Only</Text>
      <Text style={styles.copy}>
        {isLoggedIn
          ? 'This promotion is only available at participating Rewards stores.'
          : 'Sign in to view this promotion.'}
      </Text>
      {!isLoggedIn && (
        <Button
          testID="member-only-sign-in"
          title="SIGN IN"
          onPress={onSignIn}
          buttonStyle={styles.signInButton}
        />
      )}
    </View>
  </ContentView>
);

export default MemberOnlyAccessView;

const styles = StyleSheet.create({
  textCard: {
    marginTop: 24,
  },
  headline: {
    fontSize: 20,
    color: theme.colour.text.heading.primary,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  copy: {
    fontSize: 16,
  },
  signInButton: {
    marginTop: 16,
    width: '80%',
  },
});
